import { CalendarToday } from '@mui/icons-material'
import {
  Box,
  Button,
  Grid,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { BerthPlanningViewStore } from '@planning/pages/BerthPlanning/Stores/BerthPlanningViewStore'
import { RailVisitPlanningViewStore } from '@planning/pages/RailVisit/stores/RailVisitPlanningViewStore'
import { useTranslate } from '@tolgee/react'
import { ChevronLeftIcon, ChevronRightIcon, useMinimalsTheme } from '@tom-ui/ui'
import dayjs, { Dayjs } from 'dayjs'
import { observer } from 'mobx-react-lite'
import { useRef, useState } from 'react'

interface IProps {
  store: BerthPlanningViewStore | RailVisitPlanningViewStore
  title: string
}

export const CarrierVisitPlanningHeader = observer(({ store, title }: IProps) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const [open, setOpen] = useState(false)
  const anchorRef = useRef<HTMLDivElement>(null)

  const handleChange = (event: SelectChangeEvent) =>
    store.setDaysVisualization(parseInt(event.target.value) as 4 | 7)

  const handleDateChange = (date: Dayjs | null) => {
    if (date) {
      const startDate = date.subtract(1, 'day')
      store.setStartDate(startDate.toDate())
    }
    setOpen(false)
  }

  return (
    <Box>
      <Grid container alignItems='center' pb={1}>
        <Grid size={2}>
          <Typography variant='h4'>{title}</Typography>
        </Grid>

        <Grid size={6}>
          <Stack direction='row' alignItems='center' spacing={2}>
            <Stack direction='row' alignItems='center' spacing={1} ref={anchorRef}>
              <Typography
                variant='h4'
                sx={{
                  userSelect: 'none',
                }}
              >
                {dayjs(store.startDate).add(1, 'day').format('MMMM YYYY')}
              </Typography>

              <DatePicker
                open={open}
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                value={dayjs(store.startDate).add(1, 'day')}
                onChange={handleDateChange}
                format='MMMM YYYY'
                views={['year', 'month', 'day']}
                slotProps={{
                  textField: {
                    sx: { display: 'none' },
                  },
                  popper: {
                    anchorEl: anchorRef.current,
                  },
                }}
              />
              <IconButton onClick={() => setOpen(true)}>
                <CalendarToday />
              </IconButton>
            </Stack>

            <Stack spacing={1} direction='row'>
              <IconButton
                sx={{ border: `1px solid ${theme.palette.divider}` }}
                onClick={() => store.loadPrevDate()}
              >
                <ChevronLeftIcon />
              </IconButton>

              <IconButton
                sx={{ border: `1px solid ${theme.palette.divider}` }}
                onClick={() => store.loadNextDate()}
              >
                <ChevronRightIcon />
              </IconButton>
            </Stack>

            <Button color='inherit' variant='contained' onClick={() => store.goToToday()}>
              {t('today', 'Today')}
            </Button>
          </Stack>
        </Grid>

        <Grid container justifyContent='flex-end' size={4}>
          <Select onChange={handleChange} value={String(store.daysVisualization)} size='small'>
            <MenuItem value={4}>4 {t('days', 'days')}</MenuItem>
            <MenuItem value={7}>7 {t('days', 'days')}</MenuItem>
          </Select>
        </Grid>
      </Grid>
    </Box>
  )
})
